<template>
  <div class="table_warp">
    <el-table size="mini" :id="tableData.id" :data="tableData.data" :height="tableData.height" border style="width: 100%">
      <el-table-column type="index" label="序号" align="center" width="50">
      </el-table-column>
      <el-table-column v-for="(item, index) in tableData.head" :key="'tg_' + index" :prop="item.field" :label="item.label"
        :width="item.width" :min-width="item.minWidth" :align="item.align" resizable :show-overflow-tooltip="true">
      </el-table-column>
    </el-table>
    <div class="table_page" v-if="tableData.id && tableData.id.indexOf('_small') > -1">
      <el-pagination class="page_small" background layout="prev, slot, next" :page-size="tableData.limit"
        :total="tableData.count" @prev-click="(val) => changePage(val, 'prev')"
        @next-click="(val) => changePage(val, 'next')" small>
        <div class="page_solt">
          <el-input class="slot_jumper" size="mini" v-model="tableData.curr"
            @change="(val) => changePage(Number(val), 'curr')"></el-input>
          <span>/</span>
          <span>{{ tableData.page }}</span>
        </div>
      </el-pagination>
    </div>
    <div class="table_page" v-else>
      <el-pagination background :page-size="tableData.limit" :total="tableData.count"
        @prev-click="(val) => changePage(val, 'prev')" @next-click="(val) => changePage(val, 'next')"
        @current-change="(val) => changePage(val, 'curr')" @size-change="(val) => changePage(val, 'size')" small>
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableInfo: {
      type: Object,
      default: () => ({}),
    },
    autoHeight: Boolean
  },
  data() {
    return {
      tableData: []
    }
  },
  watch: {
    tableInfo() {
      this.tableData = JSON.parse(JSON.stringify(this.tableInfo))
      this.tableData.height = this.tableInfo.height ? this.tableInfo.height : 'calc(100% - 50px)'
    },
  },
  methods: {
    changePage(val, type) {
      let param = {
        pageSize: this.tableData.limit,
        pageIndex: this.tableData.curr
      }
      if (type == 'size') {
        param.pageSize = val
      } else {
        param.pageIndex = val
      }
      this.$emit('setParam', param, this.tableData.id)
    }
  },
}
</script>

<style lang="less" scoped>
.table_warp {
  height: calc(100% - 2px);
  border: 1px solid #d9d9d9;

  /deep/.el-table {
    color: #212121;
    border: none;

    th.el-table__cell {
      padding: 0;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
      color: #212121;
      font-weight: normal;
      background-color: #f2f2f2;
      border-bottom: 1px solid #d9d9d9;
      // text-align: left;

      +th.el-table__cell {
        border-left: 1px solid #d9d9d9;
      }
    }

    td.el-table__cell {
      padding: 0;
      height: 40px;
      line-height: 40px;
      border: none;
      border-bottom: 1px solid #d9d9d9;

      &:last-child {
        // text-align: right;
      }
    }

  }

  .table_page {
    padding: 0 10px;
    height: 48px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .page_small {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }

    .page_solt {
      /deep/.el-input {
        &.slot_jumper {
          width: 40px;

          .el-input__inner {
            height: 22px;
            line-height: 22px;
            border-radius: 2px;
            padding: 0 5px;
          }
        }
      }

      >span {
        font-weight: normal;
        color: #9e9e9e;
        min-width: 30px;
        text-align: center;

        +span {
          color: #212121;
          text-align: left;
        }
      }
    }
  }
}
</style>
